<template>
    <!-- 添加项目 -->
    <div class="right_container" >
        <div class="bar create_project" :style="'height:'+bar_height+'px;'">
            <span class="fl">新建项目</span>
        </div>
        <!--{{project_data}}-->
        <div class="scroll_div" :style="'height:'+ (height - bar_height - btn_height-10) +'px;overflow: auto'">
            <div v-if="createTime">
                <div class="template_wrapper">
                    <div class="template_title">创建日期</div>
                    <el-input disabled="disabled" :value="createTime"></el-input>
                </div>
            </div>

            <div>
                <div class="template_wrapper">
                    <div class="template_title">立项部门</div>
                    <el-input disabled="disabled" :value="user_info.department"></el-input>
                </div>
            </div>

            <div v-for="(item,index) in templates" :key="index+''">
                <v-datepicker v-if="item.type=='TimePicker'" :moduel="item" :projectData="project_data"  v-model='project_data[item.key_name]' :ref="'project'+item.key_name" v-on:listenToChildEvent="checkParams" type='add'> </v-datepicker>
                <v-input v-if="item.type=='input'" :moduel="item" :projectData ="project_data"  v-model='project_data[item.key_name]' :ref="'project'+item.key_name"  v-on:listenToChildEvent="checkParams" type='add'> </v-input>
                <v-select v-if="item.type=='select'"  :moduel="item" :projectData.sync ="project_data"  v-model='project_data[item.key_name]' :ref="'project'+item.key_name" v-on:listenToChildEvent="checkParams" type='add'></v-select>
                <v-selectObj v-if="item.type=='select_by_api'&&item.key_name != 'customer_ids'" :moduel="item" :projectData.sync="project_data" v-model='project_data[item.key_name]' v-on:listenToChildEvent="checkParams"  :ref="'project'+item.key_name" type='add'> </v-selectObj>
                <v-selectObj v-if="item.type=='select_by_api'&&item.key_name == 'customer_ids'" :moduel="item" :projectData.sync="project_data" v-model='project_data[item.key_name]' v-on:listenToChildEvent="checkParams" :ref="'project'+item.key_name" type='add'> </v-selectObj>
                <uc_editor v-if="item.type=='text'"  :moduel="item" :data="project_data" v-model='project_data[item.key_name]'  :ref="'project'+item.key_name"  :input_callback="set_add_project_description" v-on:listenToChildEvent="checkParams" type='add'></uc_editor>
            </div>
        </div>
        <div :style="'text-align: center;height:'+ btn_height +'px;'">
            <span class="category_btn project_btn" @click="close_add_wrapper" style="padding: 0 20px;margin: 0 50px;">取消</span>
            <span class="category_btn project_btn" :class="{'typeSelected':add_project_sunbmit}" style="padding: 0 20px;" @click="create_project" v-if="add_project_sunbmit">创建</span>
            <span class="category_btn project_btn" style="padding: 0px 20px;" v-else>创建</span>
            <div style="color: red;">
                {{project_tips}}
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name:'',
  data(){
    return {
        bar_height:40,
        btn_height:54,
        project_tips:'',
        timer:'',
        customer_ids:[],
        user_list:[],
        project_user_list:[],
        content:'',
        name:'',
        createTime:'',
        add_project_sunbmit:false,
        // show_ellipsis:false,
        description_high:0,
        function_type1:''
    }
  },
  props:["height", "width","templates",'project_id',"web_token","user_info","web_url","project_data"],
  // store,
  methods:{
    set_add_project_description: function(_content, _height){
      this.project_data.description = _content;
      this.project_data.description_high = _height;
    },
    backToLogin(){
      this.$router.push('/login');
    },
    // 获取当前时间
    getLocalTime(){
      var myDate = new Date();//获取系统当前时间
      var timestamp = myDate.getTime();
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var D = date.getDate() + ' ';
      var h = (date.getHours()+"").padLeft(2,0) + ':';
      var m = (date.getMinutes()+"").padLeft(2,0) + ':';
      var s = (date.getSeconds()+"").padLeft(2,0);
      this.createTime = (Y+M+D+h+m+s);
    },
    // 关闭新建
    close_add_wrapper(){
      var that = this;
      this.$confirm('正在新建项目，离开会丢失录入的内容，是否确定离开？', '提示', {
          cancelButtonText: '继续编辑',
          confirmButtonText: '确定离开',
          type: 'warning'
        }).then(() => {
        //TODO: 切换项目
        // that.editors_clear("project");
        that.function_type1 = 1;
        that.$emit('input', this.function_type1);
        that.project_id = '';
        }).catch(() => {

        });
    },
    checkParams(){
      this.role_change();
      for(var i=0; i< this.templates.length; i++) {
        if(this.templates[i].required){
          if(this.project_data[this.templates[i].key_name] == '' || this.project_data[this.templates[i].key_name] == []){
                this.add_project_sunbmit = false;
                return false;
          }
        }
      }
      this.add_project_sunbmit = true;
    },
    //添加项目
    create_project(){
        this.project_data.web_token = this.web_token;
        this.$http.post(this.web_url+'/project/add',this.project_data,{emulateJSON:true}).then(function(res){
            if(res.data.status == 'ok'){
                // 成功创建项目后，显示所有项目，且选中刚创建的项目。
                this.$emit("add_project_success");
                this.project_tips =  '';
            }else if(res.data.error_code == '401'){
              this.backToLogin();
            }else {
              var _this = this;
               clearInterval(this.timer);
               this.project_tips = res.data.message;
               this.timer = setInterval(function(){
                  _this.project_tips =  '';
               },2000);
            }
        })
        .catch(function(res1){
          console.log(res1);
        });
    },
    // 人员改变 项目角色不能重复
    role_change(){
      var user_role = ['leader_user_ids','manage_user_ids','join_user_ids'];
      for(var i=0; i< this.templates.length; i++) {
        if(user_role.indexOf(this.templates[i].key_name) > -1){
            var ref = 'project'+this.templates[i].key_name;
            if(ref in this.$refs){
                this.$refs[ref][0].user_change();
            }
        }
      }
    },
    editors_clear: function(name){
      for(var i=0; i< this.templates.length; i++) {
        var ref = name +this.templates[i].key_name;
        if(ref in this.$refs){
          this.$refs[ref][0].clear();
        }
      }
    },
    //重置参数 添加项目
    resetparem_project_add(){
      for(var i=0; i< this.templates.length; i++) {
        this.project_data[this.templates[i].key_name] = '';
        if(this.templates[i].type ==  'select_by_api'){
          this.project_data[this.templates[i].key_name] = [];
        }
      }
    },
    // 获取当前时间
    getLocalTime(){
      var myDate = new Date();//获取系统当前时间
      var timestamp = myDate.getTime();
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
      var D = date.getDate() + ' ';
      var h = (date.getHours()+"").padLeft(2,0) + ':';
      var m = (date.getMinutes()+"").padLeft(2,0) + ':';
      var s = (date.getSeconds()+"").padLeft(2,0);
      this.createTime = (Y+M+D+h+m+s);
      // myDate.getFullYear(); //获取完整的年份(4位,1970-????)
      // myDate.getMonth(); //获取当前月份(0-11,0代表1月)
      // myDate.getDate(); //获取当前日(1-31)
      // myDate.getTime(); //获取当前时间(从1970.1.1开始的毫秒数)
      // myDate.getHours(); //获取当前小时数(0-23)
      // myDate.getMinutes(); //获取当前分钟数(0-59)
      // myDate.getSeconds(); //获取当前秒数(0-59)
      // myDate.getMilliseconds(); //获取当前毫秒数(0-999)
      // myDate.toLocaleDateString(); //获取当前日期
      // var mytime=myDate.toLocaleTimeString(); //获取当前时间
      // myDate.toLocaleString( ); //获取日期与时间
    },
  },
  computed: {
  },
  mounted(){
       this.getLocalTime();
  },
  created() {
  },
  watch: {

  },
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/addProjectpage.vue